import { Component, Injector, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';


import { getDataScopeByPermission, isNullOrEmpty } from 'src/app/core/utils/common-functions';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';

import { CustomerLabelService } from 'src/app/features/transport-operation/services/customer-label.service';
import { CustomerLabelColumn, CustomerLabelDetail as CustomerLabelDetailRowData, CustomerLabelHeader, CustomerLabelHeaderRowData, QueryCustomerLabelRequest, QueryCustomerLabelResponse, SendCustomerLabelRequest, UpdateCustomerLabelDetailRequest, UpdateCustomerLabelHeaderRequest } from './bean/customer-label';
import { DataTableComponent } from 'src/app/shared/components/data-table/data-table.component';
import { BehaviorSubject, finalize } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { DataTableSavedBean } from 'src/app/shared/components/data-table/bean/data-table-saved-bean';
import { UserPreferenceConstants } from 'src/app/core/constants/user-preference-constants.constant';
import { CustomerLabelMapperService } from '../../services/customer-label-mapper.service';
import * as e from 'express';

@Component({
  selector: 'laas-customer-label',
  templateUrl: './customer-label.component.html',
  styleUrl: './customer-label.component.scss'
})
export class CustomerLabelComponent extends SessionBaseComponent implements OnInit {

  @ViewChild('customerLabelHeaderTable') customerLabelHeaderTable!: DataTableComponent;

  @ViewChild('customerLabelDetailTable') customerLabelDetailTable!: DataTableComponent;

  readonly viewPermission = PermissionConstants.ViewCustomerLabelMaintenance;
  readonly editPermissionCode = PermissionConstants.EditCustomerLabelMaintenance;
  currentLang: string = this.laasSetting.language;

  readonly headerPreferenceKey: string;
  readonly detailPreferenceKey: string;


  isLoadingDetail: boolean = false;
  isLoadingHeader: boolean  = false;

  searchResults: QueryCustomerLabelResponse[] = [];
  customerLabelHeaderRowData: CustomerLabelHeaderRowData | undefined ;
  customerLabelDetailRowDatas: CustomerLabelDetailRowData[] = [];
  searchForm: FormGroup;

  customerLabelHeaderColumns: any[];
  customerLabelDetailColumns: any[];


  constructor(
      injector: Injector,
      private formBuilder: FormBuilder,
      private customerLabelService: CustomerLabelService,
      private customerLabelMapperService: CustomerLabelMapperService
  ) {
    super(injector);

    this.headerPreferenceKey = UserPreferenceConstants.CustomerLabelHeaderMaintenance;
    this.detailPreferenceKey = UserPreferenceConstants.CustomerLabelDetailMaintenance;

    this.customerLabelHeaderColumns= [
      {field: CustomerLabelColumn.externOrderKey, header: 'CustomerLabelMaintenance.Column.externOrderKey', sort: 'true'},
      {field: CustomerLabelColumn.facility, header: 'CustomerLabelMaintenance.Column.facility', sort: 'true'},
      {field: CustomerLabelColumn.deliveryId, header: 'CustomerLabelMaintenance.Column.deliveryId', sort: 'true'},
      {field: CustomerLabelColumn.labelKey, header: 'CustomerLabelMaintenance.Column.labelKey', sort: 'true'},
      {field: CustomerLabelColumn.idFromCu, header: 'CustomerLabelMaintenance.Column.idFromCu', sort: 'true'},
      {field: CustomerLabelColumn.ouser2, header: 'CustomerLabelMaintenance.Column.ouser2', sort: 'true'}
    ]

    this.customerLabelDetailColumns= [
      {field: CustomerLabelColumn.externLineNumber, header: 'CustomerLabelMaintenance.Column.externLineNo', sort: 'true'},
      {field: CustomerLabelColumn.buyerPo, header: 'CustomerLabelMaintenance.Column.buyerPo', sort: 'true'},
      {field: CustomerLabelColumn.soLineNo, header: 'CustomerLabelMaintenance.Column.soLineNo', sort: 'true'},
      {field: CustomerLabelColumn.sku, header: 'CustomerLabelMaintenance.Column.sku', sort: 'true'},
      {field: CustomerLabelColumn.altSku, header: 'CustomerLabelMaintenance.Column.altSku',  sort: 'true'},
      {field: CustomerLabelColumn.altSkuDescr, header: 'CustomerLabelMaintenance.Column.altSkuDescr', sort: 'true'},
      {field: CustomerLabelColumn.altSkuSpecDescr, header: 'CustomerLabelMaintenance.Column.altSkuSpecDescr', sort: 'true'},
      {field: CustomerLabelColumn.docSku, header: 'CustomerLabelMaintenance.Column.docSku', sort: 'true'},
      {field: CustomerLabelColumn.externWorkOrder, header: 'CustomerLabelMaintenance.Column.externWorkOrder', sort: 'true'},
      {field: CustomerLabelColumn.retailSku, header: 'CustomerLabelMaintenance.Column.retailSku', sort: 'true'},
      {field: CustomerLabelColumn.custLabel01, header: 'CustomerLabelMaintenance.Column.custLabel01', sort: 'true'},
      {field: CustomerLabelColumn.custLabel02, header: 'CustomerLabelMaintenance.Column.custLabel02', sort: 'true'},
      {field: CustomerLabelColumn.custLabel03, header: 'CustomerLabelMaintenance.Column.custLabel03', sort: 'true'},
      {field: CustomerLabelColumn.custLabel04, header: 'CustomerLabelMaintenance.Column.custLabel04', sort: 'true'},
      {field: CustomerLabelColumn.custLabel05, header: 'CustomerLabelMaintenance.Column.custLabel05', sort: 'true'},
      {field: CustomerLabelColumn.glAttribute01, header: 'CustomerLabelMaintenance.Column.glAttribute01', sort: 'true'},
      {field: CustomerLabelColumn.glAttribute02, header: 'CustomerLabelMaintenance.Column.glAttribute02', sort: 'true'},
      {field: CustomerLabelColumn.glAttribute03, header: 'CustomerLabelMaintenance.Column.glAttribute03', sort: 'true'},
      {field: CustomerLabelColumn.glAttribute04, header: 'CustomerLabelMaintenance.Column.glAttribute04', sort: 'true'},
      {field: CustomerLabelColumn.glAttribute05, header: 'CustomerLabelMaintenance.Column.glAttribute05', sort: 'true'},
    ];



    this.searchForm = this.formBuilder.group({
      externOrderKey: ['', Validators.required]
    })

  }

  async ngOnInit(): Promise<void>{
    await super.ngOnInit();
    // permission Codes
    this.permissionCodes = (
      Object.values(this.userProfile.roles).reduce(
        (c: any, i: any) => c.concat(i.permissions),
        []
      ) as any
    ).map((x: any) => {
      return x.permissionCode;
    });

    //rbac to maintain this page
    var canInPage = this.permissionCodes.includes(this.viewPermission);
    if (!canInPage) {
      //go unAuthorize
      this.routeStateService.navigateTo('/Error/unAuthorize');
    }
  }

  searchBtnClick(event: any) {
    if (this.searchForm.invalid) {
      this.toastService.warn(this.translateService.instant('Common.Toast.CheckRequiredFieldsOrFieldsFormat'));
      return;
    }
    this.customerLabelHeaderTable.cancelRowEdit();
    this.customerLabelHeaderTable.isInEditMode = false;
    this.customerLabelDetailTable.cancelRowEdit();
    this.customerLabelDetailTable.isInEditMode = false;

    const request : QueryCustomerLabelRequest = {
      userDataScopes: getDataScopeByPermission(this.userProfile, this.viewPermission),
      externOrderKey: this.searchForm.controls[CustomerLabelColumn.externOrderKey].value
    }

    this.isLoadingHeader=true;
    this.isLoadingDetail = true;
    this.customerLabelService.searchCustomerLabels(request)
      .pipe(finalize(() => {
        this.isLoadingHeader = false;
        this.isLoadingDetail = false;
      }))
      .subscribe({
        next: (response:QueryCustomerLabelResponse) => {
          this.customerLabelHeaderRowData = this.customerLabelMapperService.toCustomerLabelHeaderRowData(response.header);
          this.customerLabelDetailRowDatas = this.customerLabelMapperService.toCustomerLabelDetailRowData(response.details);
        },
        error: (err: HttpErrorResponse) => {
          this.toastErrorMessage(err.error);
      }
    });
  }

  resetBtnClick(event: any) {
    this.searchForm.reset();
  }

  isHeaderColumnEditable(colField: string): boolean {
    return this.customerLabelService.isCustomerLabelHeaderEditable(colField);
  }

  isDetailColumnEditable(colField: string, isCustEditable: boolean): boolean {
    return this.customerLabelService.isCustomerLabelDetailEditable(colField, isCustEditable);
  }

  sendMail($event: any) {
    if (!this.customerLabelHeaderRowData?.externOrderKey) {
      return;
    }
    const sendMailRequest: SendCustomerLabelRequest = {
      externOrderKey: this.customerLabelHeaderRowData.externOrderKey
     };
    this.customerLabelService.sendMail(sendMailRequest).subscribe({
      next: (response:any) => {
        this.toastService.success(this.translateService.instant('Common.Toast.SendMailSuccess'));
      },
      error: (error: HttpErrorResponse) =>{
        this.toastErrorMessage(error.error);
      }
    });
  }

  saveCustomerLabelHeader(savedDataBean: DataTableSavedBean): void{
    this.isLoadingHeader = true;
    if(savedDataBean.updatedList.length==0){
      this.customerLabelHeaderTable.saveSuccessEvent()
      this.isLoadingHeader = false;
      this.searchBtnClick(null);
      return;
    }
    const customerLabelHeaderRequest: UpdateCustomerLabelHeaderRequest = {
      userId: this.userProfile.employCode,
      customerLabelHeader: savedDataBean.updatedList[0]
    };
    this.customerLabelService.updateCustomerLabelHeader(customerLabelHeaderRequest)
    .pipe(finalize(() => this.isLoadingHeader = false))
    .subscribe({
      next: (response:any) => {
        this.toastService.success(this.translateService.instant('Common.Toast.SaveSuccess'));
        this.customerLabelHeaderTable.saveSuccessEvent();
        this.searchBtnClick(null);
      },
      error: (error: HttpErrorResponse) =>{
        this.toastErrorMessage(error.error);
      }
    });
  }

  saveCustomerLabelDetail(savedDataBean: DataTableSavedBean): void{
    this.isLoadingDetail = true;
    if(savedDataBean.updatedList.length==0){
      this.customerLabelDetailTable.saveSuccessEvent()
      this.isLoadingDetail = false;
      this.searchBtnClick(null);
      return;
    }
      this.isLoadingDetail = true;
      const customerLabelDetailRequest: UpdateCustomerLabelDetailRequest = {
        userId: this.userProfile.employCode,
        externOrderKey: this.customerLabelHeaderRowData?.externOrderKey || '',
        customerLabelDetail: savedDataBean.updatedList
      };
      this.customerLabelService.updateCustomerLabelDetail(customerLabelDetailRequest)
      .pipe(finalize(() => this.isLoadingDetail = false))
      .subscribe({
        next: (response:any) => {
          this.toastService.success(this.translateService.instant('Common.Toast.SaveSuccess'));
          this.customerLabelDetailTable.saveSuccessEvent();
          this.searchBtnClick(null);
        },
        error: (error: HttpErrorResponse) =>{
          this.toastErrorMessage(error.error);
        }
      });

  }

  // 再測試看看是否可以移除此function
  dataInputValid(rowData: any): boolean {
      return true;
  }
}
